export default "__VITE_ASSET__CLmhPDCN__"